import type { ReactNode } from "react";
import { navigateSPA, teamDetailHref } from "./useURLState";

// TeamLink wraps a team's name/logo in an <a> that deep-links into
// the team-detail page in the current sport+division scope.
// Modified clicks (middle-button, cmd/ctrl, shift) fall through to
// the browser so open-in-new-tab works. Children render inside the
// anchor so a logo + name combination behaves as one link.
export function TeamLink({
  slug,
  sport,
  division,
  title,
  className,
  children,
}: {
  slug: string;
  sport: string;
  division: string;
  title?: string;
  className?: string;
  children: ReactNode;
}) {
  const href = teamDetailHref(slug, sport, division);
  return (
    <a
      href={href}
      title={title}
      className={className ? `team-link ${className}` : "team-link"}
      onClick={(e) => {
        if (
          e.button !== 0 ||
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.altKey
        ) {
          return;
        }
        e.preventDefault();
        navigateSPA(href);
      }}
    >
      {children}
    </a>
  );
}
